<!-- 決済失敗(カード関連、販売制限以外のもの) -->
<template>
  <ItemDialog ref="DialogPurchaseFailed" image-type="alert">
    <template #content-area>
      <h2>購入エラー</h2>
      <p style="text-align: justify">
        お手数ですがもう一度購入手続きをやり直してください。
      </p>
    </template>
    <template #button-area>
      <ItemButton label="OK" action-type="btn-primary" @clicked="closeDialog" />
    </template>
  </ItemDialog>
</template>

<script>
import { ref } from "vue";

export default {
  name: "DialogPurchaseFailed",
  setup(props) {
    const DialogPurchaseFailed = ref(null);

    const openDialog = () => {
      DialogPurchaseFailed.value.open();
    };

    // 決済処理続行不可なのでTOPに戻す
    const closeDialog = () => {
      DialogPurchaseFailed.value.close();
    };

    return {
      DialogPurchaseFailed,
      openDialog,
      closeDialog,
    };
  },
};
</script>
